import type { TourStep } from '../types';
import { finishStep } from './common';

export const layoutDuplicateSteps: TourStep[] = [
  {
    target: 'body',
    placement: 'center',
    title: 'Дублирование макетов',
    content: 'Варианты уже существующих картинок: близкие копии для печати или новые макеты в той же теме.',
  },
  {
    target: '[data-tour="dup-sources"]',
    title: 'Исходники',
    content: 'Загрузите JPG, PNG или WebP — каждый файл станет отдельным исходником. Первый файл создаёт задание.',
  },
  {
    target: '[data-tour="dup-format"]',
    title: 'Формат печати',
    content: '«Автоматически» распознаёт круг или A4 у каждого файла. Можно задать «Только круг» или «Лист A4» с ориентацией.',
  },
  {
    target: '[aria-label="Степень изменения"]',
    title: 'Насколько менять',
    content: '«Близко к исходнику», «С небольшими изменениями» или «Новый макет в теме». Для круга близко к исходнику есть бесплатная точная копия без модели.',
  },
  {
    target: '[data-tour="dup-copies"]',
    title: 'Сколько копий',
    content: 'От 1 до 20 на исходник, не больше 100 изображений за запуск.',
  },
  {
    target: '[data-tour="dup-model"]',
    title: 'Модель и лимит',
    content: 'Модель генерации и потолок расхода. «Параметры печати» — диаметр, DPI, белое поле и точные инструкции.',
  },
  {
    target: 'aside[aria-label="Сводка запуска"]',
    title: 'Сводка запуска',
    content: 'Сколько изображений получится, формат, модель и ориентировочная цена.',
  },
  {
    target: '[data-tour="dup-launch"]',
    title: 'Запуск',
    content: 'Если кнопка неактивна, под ней написано почему.',
  },
  {
    target: '[role="progressbar"][aria-label="Ход дублирования"]',
    title: 'Ход работы',
    content: 'Сколько готово, с ошибкой и отменено. Страница обновляется сама.',
  },
  {
    target: '[data-tour="dup-actions"]',
    title: 'Управление',
    content: '«Пауза» и «Продолжить», в «…» — «Остановить задание». Готовые результаты при остановке сохраняются.',
  },
  {
    target: '[data-testid="duplication-result-card"]',
    title: 'Результат',
    content: 'Откройте в полном размере и проверьте мелкий текст перед печатью. «Скачать» — PNG для печати.',
  },
  finishStep,
];
